module.exports = __webpack_public_path__ + "img/70aa808.jpg";